module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 900,
	"w": 420,
	"h": 450,
	"nm": "Exclusive_offer",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 5,
			"nm": "1234567890",
			"hd": true,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						210.17,
						210.59,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						25,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 74,
								"f": "LabilGrotesk-Bold",
								"t": "1234567890",
								"j": 2,
								"tr": 0,
								"lh": 88.8,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"e": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"r": 2
						},
						"a": {
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 1
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 2
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 0,
			"op": 905,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 5,
			"nm": "%",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						286.17,
						360.59,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						25,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [
				{
					"inv": false,
					"mode": "a",
					"pt": {
						"a": 0,
						"k": {
							"i": [
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"v": [
								[
									53.654,
									-78.59
								],
								[
									-64.17,
									-78.59
								],
								[
									-58.17,
									0.906
								],
								[
									57.654,
									-13.094
								]
							],
							"c": true
						},
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Mask 1"
				}
			],
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 74,
								"f": "LabilGrotesk-Bold",
								"t": "%",
								"j": 2,
								"tr": 0,
								"lh": 88.8,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"e": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"r": 2
						},
						"a": {
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 1
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 2
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 0,
			"op": 905,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 5,
			"nm": "<empty text layer>",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						249.17,
						378.59,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						25,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [
				{
					"inv": false,
					"mode": "a",
					"pt": {
						"a": 0,
						"k": {
							"i": [
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"v": [
								[
									104.428,
									-131.59
								],
								[
									-199.17,
									-131.59
								],
								[
									-192.17,
									4.117
								],
								[
									94.428,
									-32.883
								]
							],
							"c": true
						},
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Mask 1"
				}
			],
			"ef": [
				{
					"ty": 5,
					"nm": "Slider Control",
					"np": 3,
					"mn": "ADBE Slider Control",
					"ix": 1,
					"en": 1,
					"ef": [
						{
							"ty": 0,
							"nm": "Slider",
							"mn": "ADBE Slider Control-0001",
							"ix": 1,
							"v": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"t": 0,
										"s": [
											10
										]
									},
									{
										"i": {
											"x": [
												0.5
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"t": 48,
										"s": [
											10
										]
									},
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0
											],
											"y": [
												0
											]
										},
										"t": 143.07,
										"s": [
											25
										]
									},
									{
										"i": {
											"x": [
												0.5
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"t": 246.984,
										"s": [
											25
										]
									},
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0
											],
											"y": [
												0
											]
										},
										"t": 310,
										"s": [
											35
										]
									},
									{
										"i": {
											"x": [
												0.5
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"t": 421,
										"s": [
											35
										]
									},
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0
											],
											"y": [
												0
											]
										},
										"t": 484.934,
										"s": [
											20
										]
									},
									{
										"i": {
											"x": [
												0.5
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"t": 593.365,
										"s": [
											20
										]
									},
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0
											],
											"y": [
												0
											]
										},
										"t": 650.594,
										"s": [
											40
										]
									},
									{
										"i": {
											"x": [
												0.5
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"t": 817.76,
										"s": [
											40
										]
									},
									{
										"t": 878,
										"s": [
											10
										]
									}
								],
								"ix": 1
							}
						}
					]
				}
			],
			"t": {
				"d": {
					"x": "var $bm_rt;\n$bm_rt = effect('Slider Control')('Slider').value.toFixed(0);",
					"k": [
						{
							"s": {
								"s": 129,
								"f": "LabilGrotesk-Bold",
								"t": "",
								"j": 1,
								"tr": 0,
								"lh": 154.8,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 905,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "exclusive offer Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						210,
						225,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						210,
						225,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-5.165,
											3.069
										],
										[
											-3.605,
											-0.256
										],
										[
											-5.426,
											-3.445
										],
										[
											-21.56,
											-31.688
										],
										[
											32.964,
											-38.504
										],
										[
											32.964,
											-45.632
										],
										[
											-32.964,
											-37.391
										],
										[
											-11.568,
											0.063
										],
										[
											-32.964,
											45.632
										],
										[
											12.098,
											39.978
										],
										[
											12.098,
											32.849
										],
										[
											-21.104,
											37.015
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509817362,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									35.666,
									371.956
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											173.714,
											186.865
										],
										[
											110.111,
											194.814
										],
										[
											110.111,
											193.004
										],
										[
											140.056,
											171.811
										],
										[
											103.038,
											176.538
										],
										[
											103.038,
											213.819
										],
										[
											-157.179,
											213.819
										],
										[
											-157.179,
											209.757
										],
										[
											140.056,
											171.811
										],
										[
											140.056,
											122.327
										],
										[
											173.258,
											118.161
										],
										[
											157.32,
											152.108
										],
										[
											155.758,
											155.432
										],
										[
											157.58,
											158.621
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-178.045,
											136.527
										],
										[
											132.982,
											96.822
										],
										[
											132.982,
											165.583
										],
										[
											-178.045,
											205.289
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											-3.702,
											0
										],
										[
											-1.714,
											-3.01
										],
										[
											5.593,
											2.618
										]
									],
									"o": [
										[
											1.717,
											-3.001
										],
										[
											3.709,
											0
										],
										[
											-5.419,
											2.497
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-37.886,
											-89.694
										],
										[
											-29.268,
											-94.745
										],
										[
											-20.641,
											-89.677
										],
										[
											-37.833,
											-89.667
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-3.257,
											0
										],
										[
											-3.105,
											1.147
										],
										[
											4.689,
											0
										],
										[
											1.043,
											4.377
										]
									],
									"o": [
										[
											3.29,
											0
										],
										[
											-1.053,
											4.363
										],
										[
											-4.698,
											0
										],
										[
											3.143,
											1.184
										]
									],
									"v": [
										[
											-29.268,
											-80.71
										],
										[
											-19.61,
											-82.48
										],
										[
											-29.268,
											-74.855
										],
										[
											-38.934,
											-82.508
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 4,
							"ty": "sh",
							"ix": 5,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-4.809,
											0
										],
										[
											-3.543,
											-3.145
										],
										[
											0,
											0
										],
										[
											3.576,
											-3.844
										],
										[
											0.374,
											-0.353
										],
										[
											6.147,
											0
										],
										[
											0,
											-9.399
										],
										[
											-9.407,
											0
										],
										[
											0,
											9.399
										],
										[
											0.05,
											0.534
										],
										[
											-1.213,
											1.306
										],
										[
											-1.324,
											4.746
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											3.609,
											-3.171
										],
										[
											4.846,
											0
										],
										[
											0,
											0
										],
										[
											-0.658,
											5.01
										],
										[
											-0.356,
											0.384
										],
										[
											-2.996,
											-4.878
										],
										[
											-9.407,
											0
										],
										[
											0,
											9.399
										],
										[
											9.407,
											0
										],
										[
											0,
											-0.549
										],
										[
											1.384,
											-1.037
										],
										[
											3.479,
											-3.741
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-157.179,
											-7.461
										],
										[
											-42.315,
											-116.521
										],
										[
											-29.268,
											-121.436
										],
										[
											-16.216,
											-116.521
										],
										[
											-7.333,
											-108.391
										],
										[
											-13.657,
											-94.706
										],
										[
											-14.786,
											-93.659
										],
										[
											-29.268,
											-101.819
										],
										[
											-46.301,
											-84.801
										],
										[
											-29.268,
											-67.783
										],
										[
											-12.234,
											-84.801
										],
										[
											-12.395,
											-86.401
										],
										[
											-8.476,
											-89.891
										],
										[
											-1.277,
											-102.849
										],
										[
											103.038,
											-7.384
										],
										[
											103.038,
											93.513
										],
										[
											-157.179,
											126.733
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 5",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 5,
							"ty": "sh",
							"ix": 6,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-2.666,
											2.868
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.021,
											-3.776
										],
										[
											0,
											0
										],
										[
											6.372,
											0
										],
										[
											5.083,
											-4.514
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.763,
											2.972
										],
										[
											0,
											0
										],
										[
											-5.083,
											-4.514
										],
										[
											-6.371,
											0
										],
										[
											0,
											0
										],
										[
											1.049,
											-3.814
										]
									],
									"v": [
										[
											-44.711,
											-128.884
										],
										[
											-29.186,
											-145.595
										],
										[
											-13.657,
											-128.884
										],
										[
											-7.985,
											-118.577
										],
										[
											-11.441,
											-121.738
										],
										[
											-29.268,
											-128.509
										],
										[
											-47.094,
											-121.738
										],
										[
											-50.315,
											-118.68
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 6",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 6,
							"ty": "sh",
							"ix": 7,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											-8.763,
											9.424
										],
										[
											-5.852,
											0
										],
										[
											-4.161,
											-4.48
										],
										[
											8.763,
											-9.42
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-8.759,
											-9.42
										],
										[
											4.161,
											-4.48
										],
										[
											5.848,
											0
										],
										[
											8.763,
											9.424
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-44.715,
											-172.695
										],
										[
											-44.711,
											-206.875
										],
										[
											-29.182,
											-213.822
										],
										[
											-13.657,
											-206.875
										],
										[
											-13.657,
											-172.695
										],
										[
											-29.186,
											-155.986
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 7",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 7,
							"ty": "sh",
							"ix": 8,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											5.721,
											6.157
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											11.226,
											12.081
										],
										[
											7.838,
											0
										],
										[
											5.516,
											-5.934
										],
										[
											-11.227,
											-12.075
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.173,
											-8.424
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.111,
											-8.085
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											11.229,
											-12.075
										],
										[
											-5.516,
											-5.934
										],
										[
											-7.842,
											0
										],
										[
											-11.227,
											12.081
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-5.583,
											6.011
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											185.118,
											109.543
										],
										[
											140.056,
											115.198
										],
										[
											140.056,
											88.788
										],
										[
											110.111,
											92.611
										],
										[
											110.111,
											-10.499
										],
										[
											-0.074,
											-111.336
										],
										[
											-8.473,
											-133.701
										],
										[
											-24.357,
											-150.789
										],
										[
											-8.476,
											-167.879
										],
										[
											-8.473,
											-211.689
										],
										[
											-29.182,
											-220.893
										],
										[
											-49.895,
											-211.689
										],
										[
											-49.895,
											-167.879
										],
										[
											-34.011,
											-150.789
										],
										[
											-49.895,
											-133.701
										],
										[
											-58.297,
											-111.102
										],
										[
											-164.252,
											-10.499
										],
										[
											-164.252,
											127.637
										],
										[
											-164.253,
											127.637
										],
										[
											-164.253,
											111.066
										],
										[
											-185.118,
											130.299
										],
										[
											-185.118,
											213.322
										],
										[
											-164.252,
											210.659
										],
										[
											-164.252,
											220.893
										],
										[
											110.111,
											220.893
										],
										[
											110.111,
											201.943
										],
										[
											185.118,
											192.568
										],
										[
											163.722,
											155.113
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 8",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509817362,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									232.882,
									225.021
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 10,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.158,
											-0.273
										],
										[
											-0.023,
											-2.201
										],
										[
											-2.161,
											0.273
										],
										[
											0.023,
											2.204
										]
									],
									"o": [
										[
											-2.161,
											0.273
										],
										[
											0.023,
											2.204
										],
										[
											2.158,
											-0.273
										],
										[
											-0.023,
											-2.201
										]
									],
									"v": [
										[
											-0.038,
											-3.918
										],
										[
											-3.82,
											0.503
										],
										[
											0.044,
											3.917
										],
										[
											3.82,
											-0.464
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									349.993,
									368.665
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											3.276,
											9.484
										],
										[
											3.072,
											-10.29
										],
										[
											-3.276,
											-9.484
										],
										[
											-3.072,
											10.29
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									349.847,
									352.444
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.618,
											-0.079
										],
										[
											0.754,
											-3.486
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.78,
											0.352
										],
										[
											-0.79,
											-0.066
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-2.947,
											0.375
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.046,
											-4.319
										],
										[
											1.164,
											-0.148
										],
										[
											0,
											0
										],
										[
											-0.582,
											-0.093
										]
									],
									"v": [
										[
											5.156,
											-11.559
										],
										[
											-0.683,
											-5.392
										],
										[
											-0.811,
											-5.375
										],
										[
											-0.653,
											-10.612
										],
										[
											-7.005,
											-9.806
										],
										[
											-6.784,
											11.667
										],
										[
											-0.433,
											10.861
										],
										[
											-0.531,
											1.079
										],
										[
											4.469,
											-5.451
										],
										[
											7.005,
											-5.477
										],
										[
											6.942,
											-11.575
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									336.264,
									363.139
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											-2.408,
											0.303
										],
										[
											-0.026,
											-2.457
										]
									],
									"o": [
										[
											0.095,
											-2.599
										],
										[
											2.572,
											-0.329
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-4.243,
											-1.629
										],
										[
											0.027,
											-6.493
										],
										[
											4.431,
											-2.728
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											6.223,
											-0.789
										],
										[
											-0.069,
											-6.651
										],
										[
											-6.434,
											0.816
										],
										[
											-0.411,
											4.418
										],
										[
											0,
											0
										],
										[
											2.115,
											-0.27
										],
										[
											0.152,
											2.694
										],
										[
											0,
											0
										],
										[
											0.006,
											0.634
										]
									],
									"o": [
										[
											-6.352,
											0.806
										],
										[
											0.069,
											6.69
										],
										[
											5.312,
											-0.674
										],
										[
											0,
											0
										],
										[
											-0.394,
											1.872
										],
										[
											-2.615,
											0.332
										],
										[
											0,
											0
										],
										[
											0.115,
											-0.694
										],
										[
											-0.069,
											-6.563
										]
									],
									"v": [
										[
											0.02,
											-11.372
										],
										[
											-10.654,
											1.391
										],
										[
											0.461,
											11.344
										],
										[
											10.223,
											2.602
										],
										[
											4.651,
											2.841
										],
										[
											0.411,
											6.433
										],
										[
											-4.204,
											2.352
										],
										[
											10.572,
											0.479
										],
										[
											10.717,
											-1.576
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									315.322,
									365.833
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.951,
											0.246
										],
										[
											-0.503,
											0.019
										],
										[
											0,
											0
										],
										[
											1.125,
											-0.144
										],
										[
											-0.046,
											-4.575
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.951,
											0.246
										],
										[
											-0.496,
											0.023
										],
										[
											0,
											0
										],
										[
											1.118,
											-0.141
										],
										[
											-0.046,
											-4.572
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.016,
											-1.736
										],
										[
											0.375,
											-0.05
										],
										[
											0,
											0
										],
										[
											-0.664,
											-0.04
										],
										[
											-4.398,
											0.556
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.016,
											-1.737
										],
										[
											0.375,
											-0.046
										],
										[
											0,
											0
										],
										[
											-0.661,
											-0.039
										],
										[
											-4.401,
											0.56
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											13.212,
											-7.798
										],
										[
											9.186,
											-7.288
										],
										[
											9.176,
											-8.091
										],
										[
											11.969,
											-11.327
										],
										[
											13.261,
											-11.406
										],
										[
											13.205,
											-16.531
										],
										[
											10.587,
											-16.367
										],
										[
											2.824,
											-7.285
										],
										[
											2.834,
											-6.483
										],
										[
											-3.307,
											-5.703
										],
										[
											-3.317,
											-6.505
										],
										[
											-0.524,
											-9.746
										],
										[
											0.765,
											-9.824
										],
										[
											0.709,
											-14.949
										],
										[
											-1.902,
											-14.785
										],
										[
											-9.665,
											-5.703
										],
										[
											-9.655,
											-4.9
										],
										[
											-13.264,
											-4.44
										],
										[
											-13.211,
											0.639
										],
										[
											-9.603,
											0.185
										],
										[
											-9.435,
											16.572
										],
										[
											-3.087,
											15.77
										],
										[
											-3.254,
											-0.621
										],
										[
											2.887,
											-1.4
										],
										[
											3.055,
											14.99
										],
										[
											9.406,
											14.184
										],
										[
											9.239,
											-2.207
										],
										[
											13.265,
											-2.716
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									289.753,
									364.464
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											4.776,
											-0.605
										],
										[
											0.056,
											5.546
										],
										[
											-4.77,
											0.606
										],
										[
											-0.059,
											-5.592
										]
									],
									"o": [
										[
											-4.855,
											0.615
										],
										[
											-0.06,
											-5.677
										],
										[
											4.858,
											-0.615
										],
										[
											0.059,
											5.632
										]
									],
									"v": [
										[
											0.099,
											9.572
										],
										[
											-8.591,
											1.089
										],
										[
											-0.098,
											-9.615
										],
										[
											8.592,
											-1.089
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											8.592,
											-1.089
										],
										[
											-0.092,
											-8.723
										],
										[
											-8.591,
											1.089
										],
										[
											0.089,
											8.766
										]
									],
									"o": [
										[
											-8.592,
											1.089
										],
										[
											0.092,
											8.852
										],
										[
											8.674,
											-1.098
										],
										[
											-0.092,
											-8.852
										]
									],
									"v": [
										[
											-0.161,
											-15.67
										],
										[
											-15.354,
											1.947
										],
										[
											0.161,
											15.67
										],
										[
											15.358,
											-1.947
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									258.944,
									368.905
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											-2.408,
											0.306
										],
										[
											-0.026,
											-2.457
										]
									],
									"o": [
										[
											0.095,
											-2.599
										],
										[
											2.572,
											-0.323
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-4.243,
											-1.628
										],
										[
											0.027,
											-6.496
										],
										[
											4.431,
											-2.727
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											6.223,
											-0.789
										],
										[
											-0.069,
											-6.651
										],
										[
											-6.434,
											0.816
										],
										[
											-0.411,
											4.421
										],
										[
											0,
											0
										],
										[
											2.115,
											-0.27
										],
										[
											0.152,
											2.694
										],
										[
											0,
											0
										],
										[
											0.006,
											0.634
										]
									],
									"o": [
										[
											-6.348,
											0.806
										],
										[
											0.069,
											6.69
										],
										[
											5.312,
											-0.674
										],
										[
											0,
											0
										],
										[
											-0.394,
											1.872
										],
										[
											-2.615,
											0.332
										],
										[
											0,
											0
										],
										[
											0.115,
											-0.691
										],
										[
											-0.069,
											-6.563
										]
									],
									"v": [
										[
											0.02,
											-11.371
										],
										[
											-10.654,
											1.392
										],
										[
											0.461,
											11.345
										],
										[
											10.223,
											2.602
										],
										[
											4.651,
											2.841
										],
										[
											0.411,
											6.434
										],
										[
											-4.204,
											2.352
										],
										[
											10.572,
											0.477
										],
										[
											10.717,
											-1.576
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									222.814,
									377.56
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 9,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											0.214,
											4.488
										],
										[
											-5.085,
											-9.556
										],
										[
											-11.641,
											-8.724
										],
										[
											-2.957,
											11.676
										],
										[
											3.438,
											10.866
										],
										[
											11.641,
											-11.676
										],
										[
											5.168,
											-10.857
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									200.354,
									379.873
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 10,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.201,
											-0.28
										],
										[
											-0.023,
											-2.243
										],
										[
											-2.161,
											0.273
										],
										[
											0.023,
											2.247
										]
									],
									"o": [
										[
											-2.161,
											0.273
										],
										[
											0.023,
											2.247
										],
										[
											2.201,
											-0.279
										],
										[
											-0.023,
											-2.243
										]
									],
									"v": [
										[
											-0.043,
											-3.955
										],
										[
											-3.862,
											0.515
										],
										[
											0.039,
											3.962
										],
										[
											3.861,
											-0.465
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									183.332,
									365.446
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 11",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 11,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-3.285,
											-10.335
										],
										[
											-3.064,
											11.138
										],
										[
											3.285,
											10.335
										],
										[
											3.064,
											-11.138
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									183.528,
									382.556
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 12",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 12,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.579,
											0.201
										],
										[
											-0.095,
											-1.851
										],
										[
											0,
											0
										],
										[
											5.312,
											-0.671
										],
										[
											-0.046,
											-4.362
										],
										[
											-4.536,
											-0.355
										],
										[
											0,
											0
										],
										[
											-0.013,
											-1.187
										],
										[
											1.786,
											-0.224
										],
										[
											0.059,
											1.904
										],
										[
											0,
											0
										],
										[
											-5.559,
											0.708
										],
										[
											0.046,
											4.276
										],
										[
											4.907,
											0.437
										],
										[
											0,
											0
										],
										[
											0.01,
											0.931
										]
									],
									"o": [
										[
											1.908,
											-0.24
										],
										[
											0,
											0
										],
										[
											-0.168,
											-4.431
										],
										[
											-5.148,
											0.654
										],
										[
											0.036,
											3.684
										],
										[
											0,
											0
										],
										[
											1.786,
											0.197
										],
										[
											0.01,
											1.184
										],
										[
											-2.237,
											0.286
										],
										[
											0,
											0
										],
										[
											0.089,
											4.398
										],
										[
											5.355,
											-0.677
										],
										[
											-0.036,
											-3.641
										],
										[
											0,
											0
										],
										[
											-1.289,
											-0.132
										],
										[
											-0.013,
											-1.227
										]
									],
									"v": [
										[
											0.222,
											-7.056
										],
										[
											3.86,
											-4.379
										],
										[
											9.587,
											-5.23
										],
										[
											0.173,
											-11.585
										],
										[
											-8.59,
											-3.053
										],
										[
											-1.88,
											2.795
										],
										[
											0.16,
											3.006
										],
										[
											2.919,
											4.69
										],
										[
											-0.051,
											7.016
										],
										[
											-3.817,
											4.355
										],
										[
											-9.587,
											5.259
										],
										[
											-0.005,
											11.548
										],
										[
											9.093,
											3.144
										],
										[
											1.469,
											-2.76
										],
										[
											-0.571,
											-2.967
										],
										[
											-2.498,
											-4.589
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									167.973,
									384.536
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 13",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 13,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.286,
											-0.289
										],
										[
											0.029,
											2.796
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-4.566,
											0.579
										],
										[
											-1.185,
											2.062
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.033,
											3.092
										],
										[
											-2.155,
											0.273
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.056,
											5.253
										],
										[
											2.654,
											-0.339
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											3.441,
											-11.225
										],
										[
											3.562,
											0.636
										],
										[
											-0.042,
											5.925
										],
										[
											-3.533,
											1.917
										],
										[
											-3.658,
											-10.324
										],
										[
											-10.009,
											-9.518
										],
										[
											-9.874,
											3.654
										],
										[
											-2.102,
											11.448
										],
										[
											3.721,
											7.738
										],
										[
											3.661,
											10.248
										],
										[
											10.01,
											9.445
										],
										[
											9.789,
											-12.028
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									145.614,
									387.399
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 14",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 14,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.332,
											-0.043
										],
										[
											0.023,
											2.243
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-3.733,
											0.474
										],
										[
											-0.832,
											0.316
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-1.786,
											0.224
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.056,
											5.378
										],
										[
											1.372,
											-0.174
										],
										[
											0,
											0
										],
										[
											-0.329,
											0.125
										]
									],
									"v": [
										[
											4,
											8.626
										],
										[
											1.434,
											5.728
										],
										[
											1.411,
											3.399
										],
										[
											1.216,
											-15.149
										],
										[
											-5.135,
											-14.343
										],
										[
											-4.941,
											4.205
										],
										[
											-4.904,
											7.889
										],
										[
											1.773,
											14.675
										],
										[
											5.135,
											13.826
										],
										[
											5.033,
											8.327
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									127.908,
									385.669
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 15",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 15,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											11.202,
											-12.182
										],
										[
											4.475,
											-11.33
										],
										[
											0.183,
											-4.594
										],
										[
											-4.446,
											-10.199
										],
										[
											-11.587,
											-9.291
										],
										[
											-3.715,
											0.354
										],
										[
											-11.367,
											12.182
										],
										[
											-4.6,
											11.323
										],
										[
											-0.266,
											4.538
										],
										[
											4.324,
											10.192
										],
										[
											11.587,
											9.271
										],
										[
											3.594,
											-0.442
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									109.286,
									391.978
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 16",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 16,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-3.493,
											9.844
										],
										[
											-3.565,
											2.818
										],
										[
											8.676,
											1.264
										],
										[
											8.625,
											-3.775
										],
										[
											-3.618,
											-2.221
										],
										[
											-3.688,
											-9.044
										],
										[
											10.049,
											-10.784
										],
										[
											9.993,
											-16.12
										],
										[
											-10.467,
											-13.523
										],
										[
											-10.161,
											16.12
										],
										[
											10.467,
											13.504
										],
										[
											10.411,
											8.083
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									85.66,
									390.883
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 17",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 17,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 901,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "1",
			"size": 129,
			"style": "Bold",
			"w": 38.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												10.574,
												0.101
											],
											[
												0,
												0
											],
											[
												-2.417,
												3.928
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.101,
												8.56
											],
											[
												0,
												0
											],
											[
												6.949,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												18.631,
												0
											],
											[
												34.039,
												0
											],
											[
												34.039,
												-70.999
											],
											[
												20.444,
												-70.999
											],
											[
												2.518,
												-56.699
											],
											[
												2.518,
												-44.211
											],
											[
												18.329,
												-50.656
											],
											[
												18.631,
												-50.656
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "1",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "1",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "0",
			"size": 129,
			"style": "Bold",
			"w": 63.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-16.718,
												0
											],
											[
												0,
												21.954
											],
											[
												16.617,
												0
											],
											[
												0,
												-21.954
											]
										],
										"o": [
											[
												16.617,
												0
											],
											[
												0,
												-21.954
											],
											[
												-16.718,
												0
											],
											[
												0,
												21.954
											]
										],
										"v": [
											[
												31.824,
												2.014
											],
											[
												60.123,
												-35.248
											],
											[
												31.824,
												-72.51
											],
											[
												3.525,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												7.755,
												0
											],
											[
												0,
												14.401
											],
											[
												-7.755,
												0
											],
											[
												0,
												-14.401
											]
										],
										"o": [
											[
												-7.755,
												0
											],
											[
												0,
												-14.401
											],
											[
												7.755,
												0
											],
											[
												0,
												14.401
											]
										],
										"v": [
											[
												31.824,
												-11.682
											],
											[
												19.135,
												-35.248
											],
											[
												31.824,
												-58.813
											],
											[
												44.513,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "0",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "%",
			"size": 74,
			"style": "Bold",
			"w": 87.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-10.876,
												0
											],
											[
												0,
												10.373
											],
											[
												10.876,
												0
											],
											[
												0,
												-10.272
											]
										],
										"o": [
											[
												10.876,
												0
											],
											[
												0,
												-10.272
											],
											[
												-10.876,
												0
											],
											[
												0,
												10.373
											]
										],
										"v": [
											[
												21.451,
												-35.651
											],
											[
												40.787,
												-54.08
											],
											[
												21.451,
												-72.51
											],
											[
												2.216,
												-54.08
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "%",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												27.393,
												1.309
											],
											[
												70.898,
												-65.863
											],
											[
												61.029,
												-71.805
											],
											[
												17.523,
												-4.633
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "%",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 2,
								"ty": "sh",
								"ix": 3,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												4.733,
												0
											],
											[
												0,
												5.035
											],
											[
												-4.633,
												0
											],
											[
												0,
												-4.935
											]
										],
										"o": [
											[
												-4.633,
												0
											],
											[
												0,
												-4.935
											],
											[
												4.733,
												0
											],
											[
												0,
												5.035
											]
										],
										"v": [
											[
												21.451,
												-45.52
											],
											[
												13.394,
												-54.08
											],
											[
												21.451,
												-62.64
											],
											[
												29.608,
												-54.08
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "%",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 3,
								"ty": "sh",
								"ix": 4,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												10.876,
												0
											],
											[
												0,
												-10.373
											],
											[
												-10.876,
												0
											],
											[
												0,
												10.272
											]
										],
										"o": [
											[
												-10.876,
												0
											],
											[
												0,
												10.272
											],
											[
												10.876,
												0
											],
											[
												0,
												-10.373
											]
										],
										"v": [
											[
												66.971,
												-34.845
											],
											[
												47.635,
												-16.415
											],
											[
												66.971,
												2.014
											],
											[
												86.206,
												-16.415
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "%",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 4,
								"ty": "sh",
								"ix": 5,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-4.733,
												0
											],
											[
												0,
												-5.035
											],
											[
												4.633,
												0
											],
											[
												0,
												4.935
											]
										],
										"o": [
											[
												4.633,
												0
											],
											[
												0,
												4.935
											],
											[
												-4.733,
												0
											],
											[
												0,
												-5.035
											]
										],
										"v": [
											[
												66.971,
												-24.976
											],
											[
												75.027,
												-16.415
											],
											[
												66.971,
												-7.855
											],
											[
												58.813,
												-16.415
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "%",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "%",
						"np": 8,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "2",
			"size": 74,
			"style": "Bold",
			"w": 56.9,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												13.092
											],
											[
												14.905,
												0
											],
											[
												0,
												-13.696
											],
											[
												-0.403,
												-1.913
											],
											[
												0,
												0
											],
											[
												0,
												1.813
											],
											[
												-5.74,
												0
											],
											[
												0,
												-6.546
											],
											[
												24.673,
												-16.214
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												20.343,
												-11.481
											],
											[
												0,
												-14.2
											],
											[
												-14.905,
												0
											],
											[
												0,
												2.618
											],
											[
												0,
												0
											],
											[
												-0.302,
												-1.813
											],
											[
												0,
												-6.445
											],
											[
												6.042,
												0
											],
											[
												0,
												9.769
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												3.827,
												0
											],
											[
												53.577,
												0
											],
											[
												53.577,
												-12.891
											],
											[
												24.371,
												-12.387
											],
											[
												24.371,
												-12.589
											],
											[
												54.08,
												-48.541
											],
											[
												28.702,
												-72.51
											],
											[
												3.223,
												-49.246
											],
											[
												4.028,
												-42.197
											],
											[
												19.135,
												-42.801
											],
											[
												18.631,
												-48.239
											],
											[
												28.5,
												-58.813
											],
											[
												38.571,
												-47.736
											],
											[
												3.827,
												-11.179
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "2",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "2",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "3",
			"size": 74,
			"style": "Bold",
			"w": 58.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-16.315,
												0
											],
											[
												0,
												12.085
											],
											[
												9.064,
												0.806
											],
											[
												0,
												0
											],
											[
												0,
												9.064
											],
											[
												15.207,
												0
											],
											[
												0,
												-14.703
											],
											[
												0,
												0
											],
											[
												-6.848,
												0
											],
											[
												0,
												-5.539
											],
											[
												9.869,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-6.345
											],
											[
												6.244,
												0
											],
											[
												0,
												7.352
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												15.207,
												0
											],
											[
												0,
												-8.963
											],
											[
												0,
												0
											],
											[
												9.064,
												-0.504
											],
											[
												0,
												-12.286
											],
											[
												-16.315,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-7.755
											],
											[
												6.546,
												0
											],
											[
												0,
												6.042
											],
											[
												0,
												0
											],
											[
												9.164,
												0
											],
											[
												0,
												5.237
											],
											[
												-7.15,
												0
											],
											[
												0,
												0
											],
											[
												0,
												14.703
											]
										],
										"v": [
											[
												30.615,
												2.014
											],
											[
												56.195,
												-18.53
											],
											[
												40.887,
												-34.946
											],
											[
												40.887,
												-35.349
											],
											[
												56.195,
												-51.663
											],
											[
												30.515,
												-72.51
											],
											[
												2.82,
												-47.433
											],
											[
												18.832,
												-46.93
											],
											[
												30.011,
												-59.518
											],
											[
												40.686,
												-50.455
											],
											[
												25.681,
												-40.384
											],
											[
												25.681,
												-30.011
											],
											[
												40.686,
												-19.638
											],
											[
												30.515,
												-10.977
											],
											[
												18.832,
												-22.861
											],
											[
												2.921,
												-22.458
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "3",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "3",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "4",
			"size": 74,
			"style": "Bold",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.302,
												17.725
											],
											[
												0,
												0
											],
											[
												11.884,
												-11.984
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												13.293,
												-9.467
											],
											[
												0,
												0
											],
											[
												-0.201,
												16.919
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												33.133,
												0
											],
											[
												47.836,
												0
											],
											[
												47.836,
												-15.71
											],
											[
												57.101,
												-15.71
											],
											[
												57.101,
												-26.889
											],
											[
												47.836,
												-26.889
											],
											[
												47.836,
												-46.225
											],
											[
												33.939,
												-46.225
											],
											[
												33.939,
												-26.889
											],
											[
												15.408,
												-26.889
											],
											[
												15.408,
												-27.191
											],
											[
												37.061,
												-70.596
											],
											[
												21.249,
												-70.596
											],
											[
												1.813,
												-24.371
											],
											[
												1.813,
												-15.71
											],
											[
												33.133,
												-15.71
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "4",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "4",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "5",
			"size": 74,
			"style": "Bold",
			"w": 58.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.408,
												0
											],
											[
												0,
												14.603
											],
											[
												13.092,
												0
											],
											[
												3.021,
												-2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.129,
												0
											],
											[
												0,
												-6.949
											],
											[
												6.445,
												0
											],
											[
												0.302,
												6.042
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												15.61,
												0
											],
											[
												0,
												-13.998
											],
											[
												-5.338,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.511,
												-3.525
											],
											[
												6.546,
												0
											],
											[
												0,
												6.949
											],
											[
												-6.143,
												0
											],
											[
												0,
												0
											],
											[
												0.101,
												13.293
											]
										],
										"v": [
											[
												28.903,
												2.014
											],
											[
												55.389,
												-22.659
											],
											[
												32.73,
												-46.326
											],
											[
												19.638,
												-41.492
											],
											[
												19.336,
												-41.492
											],
											[
												21.149,
												-57.605
											],
											[
												53.577,
												-57.605
											],
											[
												53.577,
												-70.496
											],
											[
												8.459,
												-70.496
											],
											[
												3.827,
												-30.716
											],
											[
												19.437,
												-28.5
											],
											[
												28.903,
												-34.341
											],
											[
												39.981,
												-22.659
											],
											[
												29.004,
												-10.876
											],
											[
												18.127,
												-21.048
											],
											[
												2.719,
												-20.544
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "5",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "5",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "6",
			"size": 74,
			"style": "Bold",
			"w": 59.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-17.02,
												0
											],
											[
												0,
												13.998
											],
											[
												14.301,
												0
											],
											[
												1.611,
												-4.935
											],
											[
												0,
												0
											],
											[
												0,
												0.806
											],
											[
												-7.956,
												0
											],
											[
												-0.403,
												-6.345
											],
											[
												0,
												0
											],
											[
												14.502,
												0
											],
											[
												0,
												-23.666
											]
										],
										"o": [
											[
												15.408,
												0
											],
											[
												0,
												-13.696
											],
											[
												-7.251,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.705
											],
											[
												0,
												-13.293
											],
											[
												6.143,
												0
											],
											[
												0,
												0
											],
											[
												-0.504,
												-13.797
											],
											[
												-17.12,
												0
											],
											[
												0,
												21.249
											]
										],
										"v": [
											[
												31.824,
												2.014
											],
											[
												58.008,
												-21.652
											],
											[
												33.838,
												-44.916
											],
											[
												18.933,
												-36.356
											],
											[
												18.53,
												-36.356
											],
											[
												18.43,
												-38.974
											],
											[
												30.917,
												-59.619
											],
											[
												42.096,
												-49.146
											],
											[
												56.699,
												-49.448
											],
											[
												31.32,
												-72.51
											],
											[
												3.525,
												-34.341
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "6",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.345,
												0
											],
											[
												0,
												6.848
											],
											[
												-6.345,
												0
											],
											[
												0,
												-6.848
											]
										],
										"o": [
											[
												-6.345,
												0
											],
											[
												0,
												-6.747
											],
											[
												6.345,
												0
											],
											[
												0,
												6.848
											]
										],
										"v": [
											[
												31.824,
												-9.97
											],
											[
												21.149,
												-21.753
											],
											[
												31.824,
												-33.234
											],
											[
												42.599,
												-21.652
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "6",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "6",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "7",
			"size": 74,
			"style": "Bold",
			"w": 55.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												-23.364
											],
											[
												0,
												0
											],
											[
												-13.696,
												12.991
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												-22.961
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-15.61,
												11.884
											]
										],
										"v": [
											[
												15.106,
												0
											],
											[
												30.917,
												0
											],
											[
												53.073,
												-58.511
											],
											[
												53.073,
												-70.496
											],
											[
												2.618,
												-70.496
											],
											[
												2.618,
												-57.605
											],
											[
												40.182,
												-57.605
											],
											[
												40.182,
												-57.303
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "7",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "7",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "8",
			"size": 74,
			"style": "Bold",
			"w": 59.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.811,
												0
											],
											[
												0,
												11.984
											],
											[
												8.157,
												2.316
											],
											[
												0,
												0
											],
											[
												0,
												7.654
											],
											[
												15.207,
												0
											],
											[
												0,
												-12.286
											],
											[
												-7.352,
												-1.813
											],
											[
												0,
												0
											],
											[
												0,
												-7.654
											]
										],
										"o": [
											[
												15.811,
												0
											],
											[
												0,
												-7.654
											],
											[
												0,
												0
											],
											[
												7.352,
												-1.813
											],
											[
												0,
												-12.286
											],
											[
												-15.106,
												0
											],
											[
												0,
												7.654
											],
											[
												0,
												0
											],
											[
												-8.057,
												2.316
											],
											[
												0,
												11.984
											]
										],
										"v": [
											[
												30.112,
												2.014
											],
											[
												57.001,
												-18.228
											],
											[
												43.204,
												-35.147
											],
											[
												43.204,
												-35.449
											],
											[
												55.792,
												-51.562
											],
											[
												30.112,
												-72.51
											],
											[
												4.532,
												-51.562
											],
											[
												17.02,
												-35.449
											],
											[
												17.02,
												-35.147
											],
											[
												3.323,
												-18.228
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "8",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.244,
												0
											],
											[
												0,
												5.539
											],
											[
												-6.244,
												0
											],
											[
												0,
												-5.539
											]
										],
										"o": [
											[
												-6.244,
												0
											],
											[
												0,
												-5.539
											],
											[
												6.244,
												0
											],
											[
												0,
												5.539
											]
										],
										"v": [
											[
												30.112,
												-40.988
											],
											[
												19.537,
												-50.354
											],
											[
												30.112,
												-59.619
											],
											[
												40.686,
												-50.354
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "8",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 2,
								"ty": "sh",
								"ix": 3,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.747,
												0
											],
											[
												0,
												5.539
											],
											[
												-6.747,
												0
											],
											[
												0,
												-5.539
											]
										],
										"o": [
											[
												-6.747,
												0
											],
											[
												0,
												-5.539
											],
											[
												6.747,
												0
											],
											[
												0,
												5.539
											]
										],
										"v": [
											[
												30.112,
												-10.977
											],
											[
												18.732,
												-20.343
											],
											[
												30.112,
												-29.81
											],
											[
												41.592,
												-20.343
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "8",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "8",
						"np": 6,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "9",
			"size": 74,
			"style": "Bold",
			"w": 59.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												17.02,
												0
											],
											[
												0,
												-13.998
											],
											[
												-14.301,
												0
											],
											[
												-1.611,
												4.935
											],
											[
												0,
												0
											],
											[
												0,
												-0.806
											],
											[
												8.057,
												0
											],
											[
												0.403,
												6.345
											],
											[
												0,
												0
											],
											[
												-14.502,
												0
											],
											[
												0,
												23.666
											]
										],
										"o": [
											[
												-15.408,
												0
											],
											[
												0,
												13.696
											],
											[
												7.251,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.705
											],
											[
												0,
												13.293
											],
											[
												-6.143,
												0
											],
											[
												0,
												0
											],
											[
												0.504,
												13.797
											],
											[
												17.12,
												0
											],
											[
												0,
												-21.249
											]
										],
										"v": [
											[
												29.407,
												-72.51
											],
											[
												3.223,
												-48.843
											],
											[
												27.393,
												-25.58
											],
											[
												42.297,
												-34.14
											],
											[
												42.7,
												-34.14
											],
											[
												42.801,
												-31.522
											],
											[
												30.313,
												-10.876
											],
											[
												19.135,
												-21.35
											],
											[
												4.532,
												-21.048
											],
											[
												29.91,
												2.014
											],
											[
												57.706,
												-36.154
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "9",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-6.345,
												0
											],
											[
												0,
												-6.848
											],
											[
												6.345,
												0
											],
											[
												0,
												6.848
											]
										],
										"o": [
											[
												6.345,
												0
											],
											[
												0,
												6.747
											],
											[
												-6.345,
												0
											],
											[
												0,
												-6.848
											]
										],
										"v": [
											[
												29.407,
												-60.526
											],
											[
												40.082,
												-48.743
											],
											[
												29.407,
												-37.262
											],
											[
												18.631,
												-48.843
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "9",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "9",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Exclusive_offer.json
// module id = 46
// module chunks = 0